import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClock } from '@fortawesome/pro-regular-svg-icons/faClock';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

import { Button } from 'ui-components/components/button/';

import UserDateFormat from '../../../../../components/user-date-timezone-format';
import { emptyArray } from 'ui-components/default-props/empty';

import messages from './messages';
import styles from './styles.module.less';

const renderEmpty = () => (
  <div className={styles.empty}>
    <FormattedMessage {...messages.noActivity} />
  </div>
);

const renderActivities = (activity, loadMoreActivities) => (
  <>
    <div className={styles.activities}>
      {activity.map(({ logId, time, message }) => (
        <div key={logId} className={styles.item}>
          <div className={styles.timestamp}>
            <FontAwesomeIcon className={styles.icon} icon={faClock} />
            <UserDateFormat dateTime={time} showTime />
          </div>
          <p>{message}</p>
        </div>
      ))}
    </div>
    <div className={styles['activity-footer']}>
      <Button onClick={loadMoreActivities} theme='link'>
        <FormattedMessage {...messages.loadMore} />
      </Button>
    </div>
  </>
);

const UserActivity = ({ activity = emptyArray, loadMoreActivities }) => {
  const hasActivity = activity.length > 0;
  return hasActivity ? renderActivities(activity, loadMoreActivities) : renderEmpty();
};

UserActivity.propTypes = {
  activity: PropTypes.arrayOf(
    PropTypes.shape({
      time: PropTypes.string,
      message: PropTypes.string,
    }),
  ),
  loadMoreActivities: PropTypes.func.isRequired,
};

export default UserActivity;
